<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="بعد-ساعتين">
<h1><span dir="rtl">بعد ساعَتين</span></h1>
<p style="text-indent:1em;"><span dir="rtl">انتَهت المُباراة بتتويج فريق العُروبة ببطولة أوّل دوريٍّ في الإمارات.</span></p>
<p><span dir="rtl">وقع نظره على هاشم بين جماهير العُروبة وأرسل له ابتسامةً من مكانه، حاول "سيف" الوُصول إليه وقبل أن يقترب منه أمسكَت "عفراء" بيد "سيف".</span></p>
<p><span dir="rtl">ظلّ هاشم واقفًا في مكانه يُراقب ردَّة فعل "سيف".</span></p>
<p><span dir="rtl">سحب "سيف" يده، ثمَّ توجَّه نحو "ميثة" وأمسك يدها بعد أن ابتسم لها ومضى إلى هاشم، وعفراء تنظر إليهما.</span></p>
<p><span dir="rtl">عانقه سيف مرحّبًا وهمس في أذنه:</span></p>
<p><span dir="rtl">- انتهى كلُّ شيءٍ إذًا!</span></p>
<p><span dir="rtl">ردّ هاشم: نعم، انتهى كلُّ شيء.</span></p>
<p><span dir="rtl">عندما فرَغَا من السّلام والتّرحيب، ذكّره هاشم بالوعد الَّذي بينهما:</span></p>
<p><span dir="rtl">- لقد وعدتني بأنَّك ستأتي معي إلى بغداد لعند أمّك عندما ينتهي كلُّ شيءٍ.</span></p>
<p><span dir="rtl">اكتفى سيف بابتسامةٍ، ثمَّ التفتَ إلى "ميثة" وقال:</span></p>
<p><span dir="rtl">- نادي الأولادَ ليُسلِّموا على ابن خالي.</span></p>
<p><span dir="rtl">مضت "ميثة" إلى حيثُ الأولاد.</span></p>
<p><span dir="rtl">سألَه هاشم وهو ينظرُ إلى عفراء:</span></p>
<p><span dir="rtl">- أهذه عفراء إذًا؟</span></p>
<p><span dir="rtl">حاول سيف ألّا ينظر إليها:</span></p>
<p><span dir="rtl">- نعم، هي، المُقيمة في ذاكرتي.</span></p>
<p><span dir="rtl">- لم أفهم!</span></p>
<p><span dir="rtl">- تركتني في عزّ احتياجي لها وسافَرت بحجّة الدّراسة منذُ أربعِ سنواتٍ، رحلَت بجسدها لكنّ حبّها ظلَّ هنا، "أشار إلى ناحية قلبه وأكمل قائلًا: "وفي خيالي".</span></p>
<p><span dir="rtl">- أبقِها إذًا في خيالك لتستطيعَ العيش بسلامٍ!</span></p>
<p><span dir="rtl">- صدِّقني لم يعُد لها وجودٌ في واقعي بعد الآن.</span></p>
<p><span dir="rtl">- أتمنّى ذلك حقًّا، لكنّها رجعت وهي هنا الآن! وأنتَ تعرف بأنَّها هنا من أجلك!</span></p>
<p><span dir="rtl">- لم تعدْ تَعني لي شيئًا، هي حتّى لا تشبه حبيبتي عفراء الَّتي تعرَّفت عليها قبل سنوات.</span></p>
<p><span dir="rtl">- كيف لا تُشبهها؟ اشرح لي، لأنّني لم أفهم!</span></p>
<p><span dir="rtl">ردّ مبتسمًا: هذا أفضل.</span></p>
<p><span dir="rtl">- المهمّ الآن كيف معنويّاتك للعودة إلى بغداد؟</span></p>
<p><span dir="rtl">- تقصدُ لزيارة بغداد.</span></p>
<p><span dir="rtl">- لكنَّك وعدتني!</span></p>
<p><span dir="rtl">- سأوفي بوعدي وأزور أمّي، لكنّني لا أفكّر بالاستقرار هناك.</span></p>
<p><span dir="rtl">- لم يكن هذا رأيكَ قبل أربع سنواتٍ!</span></p>
<p><span dir="rtl">- وقتها كنتُ أريد الابتعاد عن كلِّ شيءٍ يذكّرني بها.</span></p>
<p><span dir="rtl">- والآن!</span></p>
<p><span dir="rtl">- لا يهمُّ إن كانت هنا أو في لندن؛ فوجودُها لم يعد مؤثّرًا في حياتي، لقد تعايَشْتُ مع غيابها، وأيضًا لا تستحقُّ أن أترك بلدي من أجلها خاصّةً في هذا الوقت!</span></p>
<p><span dir="rtl"><br/>
</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch006.vue?2d9bc8e2